module.exports = __webpack_public_path__ + "static/media/licensed.bca18e2f.png";